import type { Collection } from "@/types/comic";

export const collections: Collection[] = [
  {
    id: "campus-love",
    title: "校园爱情精选",
    description: "校服、操场与偷偷的心动，青春里最干净的喜欢都藏在这里。",
    tag: "青春校园",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20sunlit%20high%20school%20campus%20with%20cherry%20blossoms%20and%20a%20quiet%20classroom%20window%20seat%2C%20nostalgic%20soft%20pastel%20illustration%2C%20no%20text%2C%20airy%20clean%20composition%2C%20warm%20spring%20afternoon%20light%2C%20modern%20artistic%20webtoon%20background%20aesthetic&width=800&height=600&seq=collection-01&orientation=landscape",
    comicIds: ["confession-under-blossom", "bad-senior-secret", "heart-signal"],
  },
  {
    id: "fantasy-adventure",
    title: "奇幻冒险合集",
    description: "魔法、巨龙与未知大陆，一场说走就走的异世界冒险正在召唤你。",
    tag: "史诗幻想",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20fantasy%20landscape%20with%20floating%20islands%2C%20ancient%20ruins%20and%20a%20glowing%20dragon%20silhouette%20in%20a%20dramatic%20sky%2C%20rich%20concept%20illustration%2C%20no%20text%2C%20clean%20composition%2C%20golden%20hour%20lighting%2C%20modern%20artistic%20webtoon%20background%20aesthetic&width=800&height=600&seq=collection-02&orientation=landscape",
    comicIds: ["starry-magic-academy", "dragon-knight", "path-of-fist"],
  },
  {
    id: "healing-night",
    title: "深夜治愈专场",
    description: "睡不着的时候，就让这些温柔的故事陪你把心慢慢安放下来。",
    tag: "暖心舒缓",
    image:
      "https://readdy.ai/api/search-image?query=Peaceful%20cosy%20room%20at%20night%20with%20warm%20lamp%20light%2C%20a%20cup%20of%20tea%20and%20a%20sleeping%20cat%20by%20the%20window%2C%20gentle%20calm%20illustration%2C%20no%20text%2C%20soft%20muted%20tones%2C%20soothing%20atmosphere%2C%20modern%20artistic%20webtoon%20background%20aesthetic&width=800&height=600&seq=collection-03&orientation=landscape",
    comicIds: ["cat-cafe-diary", "seoul-love-guide", "changan-moonlit-night"],
  },
];